import { Controller } from "@hotwired/stimulus";

// Handles the domain-specific Members upload panel:
// - Card selection sets member_import_mode + member_upload_category
// - Shows file upload when a card is selected
// - Enables submit when card + file selected
// - Updates confirmation summary
export default class extends Controller {
  static targets = ["modeInput", "categoryInput", "fileUpload", "confirmation", "submitBtn", "cardLabel"];
  static values = {
    cardLabels: Object,
  };

  connect() {
    this.cardLabels = this.cardLabelsValue || {
      members: "Members",
      churned: "Churned",
      frozen: "Frozen",
      mixed: "Mixed",
    };
    this.syncFromCard();
  }

  selectCard(event) {
    const radio = event.target;
    if (radio.dataset.modeValue === undefined) return;
    this.updateHiddenFields(radio.dataset.modeValue, radio.dataset.categoryValue || "");
    this.updateVisibility();
  }

  syncFromCard() {
    const checked = this.element.querySelector('input[name="member_import_type_card"]:checked');
    if (checked) {
      this.updateHiddenFields(checked.dataset.modeValue || "", checked.dataset.categoryValue || "");
    }
    this.updateVisibility();
  }

  onFileChange() {
    this.updateVisibility();
    this.updateConfirmation();
  }

  updateHiddenFields(mode, category) {
    if (this.hasModeInputTarget) this.modeInputTarget.value = mode;
    if (this.hasCategoryInputTarget) this.categoryInputTarget.value = category;
  }

  updateVisibility() {
    const checked = this.element.querySelector('input[name="member_import_type_card"]:checked');
    const hasType = checked && (checked.dataset.modeValue === "full_import" || (checked.dataset.categoryValue || "").length > 0);
    const fileInput = this.element.querySelector('input[type="file"][name="file"]');
    const hasFile = fileInput && fileInput.files && fileInput.files.length > 0;

    if (this.hasFileUploadTarget) {
      this.fileUploadTarget.classList.toggle("hidden", !hasType);
    }
    if (this.hasConfirmationTarget) {
      this.confirmationTarget.classList.toggle("hidden", !(hasType && hasFile));
    }
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = !(hasType && hasFile);
    }
  }

  updateConfirmation() {
    if (!this.hasConfirmationTarget) return;
    const checked = this.element.querySelector('input[name="member_import_type_card"]:checked');
    const fileInput = this.element.querySelector('input[type="file"][name="file"]');
    const typeLabel = checked ? (this.cardLabels[checked.value] || checked.value) : "—";
    const fileName = fileInput?.files?.[0]?.name || "—";
    const categoryEl = this.confirmationTarget.querySelector("[data-role='category']");
    const fileEl = this.confirmationTarget.querySelector("[data-role='file-name']");
    if (categoryEl) categoryEl.textContent = typeLabel;
    if (fileEl) fileEl.textContent = fileName;
  }
}
